import { exp_n_477_B } from './exp-n-477/exp_n_477_B';
import { exp_n_477_C } from './exp-n-477/exp_n_477_C';
import { exp_n_522_B } from './exp-n-522/exp_n_522_B';
import { exp_n_522_C } from './exp-n-522/exp_n_522_C';
import { exp_n_522_D } from './exp-n-522/exp_n_522_D';
import { exp_n_630_B } from './exp-n-630/exp_n_630_B';
import { TestConfigVariant } from '../types/experiment';

export const testConfigs: TestConfigVariant[] = [
  exp_n_477_B,
  exp_n_477_C,
  exp_n_522_B,
  exp_n_522_C,
  exp_n_522_D,
  exp_n_630_B,
];
